import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { NavLink } from 'react-router-dom';
import { useState } from 'react'




const MenuBar = () => {

  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);





  const showDropdown = (e) => {
    setShow(!show);
  }
  const hideDropdown = (e) => {
    setShow(false);
  }
  const showDropdown1 = (e) => {
    setShow1(!show1);
  }
  const hideDropdown1 = (e) => {
    setShow1(false);
  }



  // const showDropdown2 = (e) => {
  //   setShow2(!show2);
  // }
  // const hideDropdown2 = (e) => {
  //   setShow2(false);
  // }

  const showDropdown3 = (e) => {
    setShow3(!show3);
  }
  const hideDropdown3 = (e) => {
    setShow3(false);
  }
  const showDropdown4 = (e) => {
    setShow4(!show4);
  }
  const hideDropdown4 = (e) => {
    setShow4(false);
  }



  const showDropdown6 = (e) => {
    setShow6(!show6);
  }
  const hideDropdown6 = (e) => {
    setShow6(false);
  }



  const showDropdown5 = (e) => {
    setShow5(!show5);
  }
  const hideDropdown5 = (e) => {
    setShow5(false);
  }




  return (

    <>

      {/* <!-- Header Top --> */}

      <header className="main-header header-style-one" id='hide_mobile'>
        {/* <!-- Header Top --> */}
        <div className="header-top">
          <div className="auto-container">
            <div className="inner clearfix">
              <div className="top-left clearfix">
                <ul className="info clearfix">
                  <li><NavLink to="tel:+1 (289) 389-5311"><span className="icon fa fa-phone-alt"></span>  &nbsp;+1 (289) 389-5311</NavLink></li>
                  <li><NavLink to="mailto:info.ca@yugalkunj.org"><span className="icon fa fa-envelope-open"></span> Email: &nbsp;info.ca@yugalkunj.org</NavLink></li>



                </ul>
              </div>



              <div className="top-right  clearfix ">



                <ul className="info clearfix">
                  <li><NavLink to="https://www.facebook.com/yugalkunj/" target="_blank"><span className="icon fa fa-clock"></span>  Mon - Sun : 7:00 AM -
                    12:00 PM </NavLink></li>

                  <li><NavLink to="https://www.facebook.com/yugalkunj/" target="_blank"><span className="icon fa fa-clock"></span> Mon - Sun : 3:00 PM - 8:00 PM </NavLink></li>

                  {/* <li><NavLink to="https://www.facebook.com/yugalkunj/" target="_blank"><span className="icon fa fa-clock"></span>   Sat - Sun : 7:00 AM - 8:00 PM </NavLink></li> */}
                </ul>
                <ul className="social-links clearfix ">
                  <li><NavLink to="https://www.facebook.com/yugalkunjcanada" target="_blank"><span className="fab fa-facebook-f"></span></NavLink></li>
                  {/* <li><NavLink to="https://twitter.com/search?q=yugalkunj" target="_blank"><span className="fab fa-twitter"></span></NavLink></li>
                  <li><NavLink to="https://www.yelp.com/biz/yugal-kunj-duluth-2" target="_blank"><span className="fab fa-yelp"></span></NavLink></li> */}
                  <li><NavLink to="https://www.youtube.com/@YugalKunjCanada375" target="_blank"><span className="fab fa-youtube"></span></NavLink></li>
                  <li><NavLink to="https://www.instagram.com/yugalkunj_canada/" target="_blank"><span className="fab fa-instagram"></span></NavLink></li>

                  {/* <li><NavLink to="https://video.search.yahoo.com/search/video;_ylt=AwrC1DGkf51cEi8A_gzQtDMD;_ylu=X3oDMTB0N2Noc21lBGNvbG8DYmYxBHBvcwMxBHZ0aWQDBHNlYwNwaXZz?p=yugal+kunj+duluth+ga&fr2=piv-web&fr=yfp-t-s" target="_blank"><span className="fab fa-yahoo"></span></NavLink></li> */}





                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>

      <Navbar collapseOnSelect expand="lg" className='navbarbg' >
        <Container>

          <Navbar.Brand href="/" className='logo'>
            <img src='https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png' className="logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
            <Nav className="me-auto">
              <Nav.Link href="/CAD/Home">Home </Nav.Link>
              {/* <Nav.Link href="/MyGallery" >Gallery</Nav.Link> */}
              <Nav.Link href="/CAD/about">About Us</Nav.Link>
              <NavDropdown
                title="DIDI JI "
                className="dropdown"
                id="collasible-nav-dropdown" show={show}
                onMouseEnter={showDropdown}
                onMouseLeave={hideDropdown}>

                <NavDropdown.Item href="/CAD/AboutDidiJi" >About Didi Ji</NavDropdown.Item>
                <NavDropdown.Item href="/CAD/VideoLectures">
                  Video Lectures
                </NavDropdown.Item>
                <NavDropdown.Item href="/CAD/WordsOfWisdom">Words of Wisdom</NavDropdown.Item>


              </NavDropdown>

              <Nav.Link href="/CAD/Gallery">GALLERY</Nav.Link>
              <NavDropdown title="REGISTRATION " id="collasible-nav-dropdown" show={show1}
                onMouseEnter={showDropdown1}
                onMouseLeave={hideDropdown1}>
                <NavDropdown.Item href="https://ykportal.yugalkunj.org/?ParamCountry=Canada" target="_blank">Retreat</NavDropdown.Item>
                <NavDropdown.Item href="https://summercamp.harmonyyouthcenter.org/" target="_blank">Camp</NavDropdown.Item>

                {/* <NavDropdown.Item href="https://ykportal.yugalkunj.org/?ParamCountry=USA">
                  Camp
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item href="https://ykportal.yugalkunj.org/?ParamCountry=USA">Class</NavDropdown.Item> */}



              </NavDropdown>



              <NavDropdown title="Events" id="collasible-nav-dropdown" show={show3}
                onMouseEnter={showDropdown3}
                onMouseLeave={hideDropdown3}>
                <NavDropdown.Item href="/CAD/AllEvent" >Upcoming Events</NavDropdown.Item>

                <NavDropdown.Item href="/CAD/TempleActivities">
                  Temple Activities
                </NavDropdown.Item>
                <NavDropdown.Item href="/CAD/ActivityCalendar">Yugal Kunj Calendar</NavDropdown.Item>
                
              </NavDropdown>
              {/* <NavDropdown title="VOLUNTEER " id="collasible-nav-dropdown" show={show4}
                onMouseEnter={showDropdown4}
                onMouseLeave={hideDropdown4}>

                <NavDropdown.Item href="https://donation.yugalkunj.org/">
                  Donate
                </NavDropdown.Item>



              </NavDropdown> */}

              {/* <NavDropdown.Item href="/CAD/Contact">Contact</NavDropdown.Item> */}
              {/* <NavDropdown title="Contact " id="collasible-nav-dropdown" show={show5}
                onMouseEnter={showDropdown5}
                onMouseLeave={hideDropdown5}>
                <NavDropdown.Item href="/CAD/Direction" >Directions</NavDropdown.Item>





              </NavDropdown> */}

              <Nav.Link href="/CAD/VolunteerRegistration">Volunteer Registration </Nav.Link>

              <Nav.Link href="/CAD/Contact">Contact</Nav.Link>
              <NavDropdown title="Country " id="collasible-nav-dropdown" show={show6}
                onMouseEnter={showDropdown6}
                onMouseLeave={hideDropdown6}>

                <NavDropdown.Item href="/USA/Home">USA</NavDropdown.Item>





              </NavDropdown>

              <div className="donate-link">
                <a href="https://donation.yugalkunj.org/" className="theme-btn btn-style-one" target="_blank"><span className="btn-title">Donate
                  Now</span></a>
              </div>
            </Nav>

          </Navbar.Collapse>

        </Container>
      </Navbar>




    </>

  )


}

export default MenuBar;